import React, { useContext, useEffect } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { ProviderIncomeDashboard } from '../IncomeDashboard';
import { useMediaQuery } from '@mui/material';


/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end


const TwoLevelPieChart = ({ year, dataSeries1, dataSeries2 }) => {

    const {
        arrMuseum,
        option,
    } = useContext(ProviderIncomeDashboard);
    const matchesUp768 = useMediaQuery('(min-width:768px)');

    useEffect(() => {
        // Create chart instance
        let chart = null;

        let hasValueOut = dataSeries1.findIndex(f => f.value !== 0) !== -1;
        let hasValueIn = dataSeries2.findIndex(f => f.value !== 0) !== -1;

        if (hasValueOut || hasValueIn) {
            chart = am4core.create("chart-pie-" + year, am4charts.PieChart);

            let title = chart.titles.create();
            title.text = "ปี " + year;
            title.fontSize = 16;
            title.align = "center";
            title.fontWeight = '400';

            chart.innerRadius = am4core.percent(30);

            let pieSeries = chart.series.push(new am4charts.PieSeries()) as any;
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "label";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.innerRadius = 10;
            pieSeries.slices.template.fillOpacity = 0.5;
            pieSeries.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            pieSeries.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            pieSeries.labels.template.fontSize = 10;
            pieSeries.tooltip.label.wrap = true;
            pieSeries.tooltip.label.width = 300;
            pieSeries.labels.template.maxWidth = matchesUp768 ? 180 : 100;
            pieSeries.labels.template.wrap = true;
            // pieSeries.alignLabels = true;

            pieSeries.slices.template.propertyFields.fill = "sColor";
            pieSeries.slices.template.propertyFields.disabled = "labelDisabled";
            pieSeries.labels.template.propertyFields.disabled = "labelDisabled";
            pieSeries.ticks.template.propertyFields.disabled = "labelDisabled";
            pieSeries.dataFields.hiddenInLegend = "disableLegend";


            // Add data
            pieSeries.data = dataSeries1

            // Disable sliding out of slices
            pieSeries.slices.template.states.getKey("hover").properties.shiftRadius = 0;
            pieSeries.slices.template.states.getKey("hover").properties.scale = 1;

            // Add second series
            let pieSeries2 = chart.series.push(new am4charts.PieSeries());
            pieSeries2.dataFields.value = "value";
            pieSeries2.dataFields.category = "label";
            pieSeries2.slices.template.states.getKey("hover").properties.shiftRadius = 0;
            pieSeries2.slices.template.states.getKey("hover").properties.scale = 1;
            pieSeries2.slices.template.propertyFields.fill = "sColor";
            pieSeries2.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            pieSeries2.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            pieSeries2.labels.template.fontSize = 10;
            pieSeries2.tooltip.label.wrap = true;
            pieSeries2.tooltip.label.width = 300;
            pieSeries2.labels.template.maxWidth = matchesUp768 ? 180 : 100;
            // pieSeries2.labels.template.maxWidth = 180;
            pieSeries2.labels.template.wrap = true;
            pieSeries2.dataFields.hiddenInLegend = "disableLegend";
            // pieSeries2.alignLabels = true;


            // Add data
            pieSeries2.data = dataSeries2;

            pieSeries.adapter.add("innerRadius", function (innerRadius, target) {
                return am4core.percent(40);
            })

            pieSeries2.adapter.add("innerRadius", function (innerRadius, target) {
                return am4core.percent(60);
            })

            pieSeries.adapter.add("radius", function (innerRadius, target) {
                return am4core.percent(100);
            })

            pieSeries2.adapter.add("radius", function (innerRadius, target) {
                return am4core.percent(80);
            })

            // Create the legend
            let legend = new am4charts.Legend();
            chart.legend = legend;
            legend.position = "bottom";
            legend.valueLabels.template.text = "{value.percent.formatNumber('#.00')}%";

        }
        else {
            chart = am4core.create("chart-pie-" + year, am4charts.PieChart);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let title = chart.titles.create();
            title.text = "ปี " + year;
            title.fontSize = 16;
            title.align = "center";
            title.fontWeight = '400';

            let lsEmpty = [{
                "sField": "Dummy",
                "disabled": true,
                "sValue": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];

            let lstMeseumSelect = option.lstMuseum.filter(f=>arrMuseum.includes(f.value));
            if(lstMeseumSelect.length !== 0){
                lstMeseumSelect.forEach(element => {
                    lsEmpty.push({
                        "sField": element.label,
                        "disabled": false,
                        "sValue": 0,
                        "color": am4core.color("#dadada"),
                        "opacity": 0.3,
                        "strokeDasharray": "4,4",
                        "tooltip": element.label,
                    })
                });
            }
            chart.data = lsEmpty;
            chart.radius = am4core.percent(70);
            chart.innerRadius = 40;

            let series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "sValue";
            series.dataFields.category = "sField";
            series.dataFields.hiddenInLegend = "disabled";
            series.labels.template.fontSize = 10;
            series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            series.tooltip.label.wrap = true;
            series.tooltip.label.width = 300;
            series.labels.template.maxWidth = 180;
            series.labels.template.wrap = true;

            /* Set tup slice appearance */
            let slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";

            /* This creates initial animation */
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;
        }

        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };

    }, [arrMuseum, dataSeries1, dataSeries2, option.lstMuseum, year])


    return (
        <div id={"chart-pie-" + year} style={{ width: "100%", height: "300px" }}></div>
    )
}

export default TwoLevelPieChart